ko.components.register('user-acl-groups-editor', {
	viewModel: function(opts) {
		var self = this;

		self.loading = ko.observable(false);

		self.projects = ko.observableArray();
		self.groups = ko.observableArray();
		self.data = ko.observable();

		for(var k in opts.groups)
		{
			if(!opts.groups.hasOwnProperty(k))
				continue;
			self.groups.push(new AclGroup(opts.groups[k]));
		}

		for(k in opts.projects)
		{
			if(!opts.projects.hasOwnProperty(k))
				continue;

			var ids = (opts.projects[k].groups || []).map(parseInt);

			opts.projects[k].groupsSelected = self.groups().filter(function(group){
				return ids.indexOf(group.id()) !== -1;
			});
			opts.projects[k].groups = self.groups();

			var project = new Project(opts.projects[k]);

			self.projects.push(project);
		}

		self.getData = function(){
			var data = [];
			for(var i in self.projects())
			{
				var p = self.projects()[i];

				if(p.selected())
					for(var j in p.groupsSelected())
					{
						var g = p.groupsSelected()[j];
						data.push([p.id(), g.id()]);
					}
			}
			return data;
		};

		self.hasChanges = ko.computed(function(){
			return (self.data() !== ko.toJSON(self.getData()));
		});

		self.saveChanges = function(){
			if(self.loading())
				return;
			self.loading(true);
			var json = ko.toJSON(self.getData());
			$.ajax({
				type: 'post',
				data: $.extend({ 'do': 'save', 'json': json }, App.csrf||{}),
				dataType: 'json',
				complete: function(){ self.loading(false); },
				success: function(r){
					if(r) {
						if(r.ok)
							self.data(json);
						else if(r.error)
							alert(r.error);
					}
				}
			});
		};

		self.data(ko.toJSON(self.getData()));
	},
	template: "<h3>User Projects\n\t<button class=\"btn btn-primary btn-sm ml-4\" data-bind=\"visible: hasChanges(), disabled: loading, click: saveChanges\">Save Changes</button></h3>\n<div class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\">\n\t<span class=\"ic ic-warning text-danger\"></span> Don't forget to add some restrictions! Example Main Website View, 301 View, PBN View.\n\t<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"acl\">\n\t<table class=\"table table-responsive\">\n\t<thead>\n\t<tr>\n\t\t<th scope=\"col\">Project</th>\n\t\t<th scope=\"col\">Permissions Groups</th>\n\t</tr>\n\t</thead>\n\n\t<tbody data-bind=\"foreach: projects\">\n\t<tr data-bind=\"css: { 'active': selected() }\">\n\t\t<td>\n\t\t\t<label>\n\t\t\t\t<input type=\"checkbox\" data-bind=\"checked: selected\" />\n\t\t\t\t<span data-bind=\"text: title\"></span>\n\t\t\t</label>\n\t\t</td>\n\t\t<td>\n\t\t\t<div data-bind=\"visible: !selected()\"><small class=\"badge badge-danger\">access denied</small></div>\n\n\t\t\t<table class=\"table-hover table-sm table-borderless\" data-bind=\"visible: selected()\">\n\t\t\t<thead data-bind=\"visible: selected() && groupsSelected().length == 0\">\n\t\t\t<tr>\n\t\t\t\t<td><small class=\"badge badge-warning\">no permissions</small></td>\n\t\t\t\t<td></td>\n\t\t\t</tr>\n\t\t\t</thead>\n\n\t\t\t<tbody data-bind=\"foreach: groupsSelected()\">\n\t\t\t<tr>\n\t\t\t\t<td><a data-bind=\"text: name, attr: {href: url}\" target=\"_blank\"></a></td>\n\t\t\t\t<td><button class=\"btn btn-outline-danger btn-sm float-right\" data-bind=\"click: $parent.removeGroup\"><span class=\"ic ic-remove\"></span></button></td>\n\t\t\t</tr>\n\t\t\t</tbody>\n\t\t\t<tfoot data-bind=\"visible: getGroups().length > 0\">\n\t\t\t<tr>\n\t\t\t\t<td><select class=\"form-control form-control-sm m-0\" data-bind=\"value: group, options: getGroups(), optionsText: 'name'\"></select></td>\n\t\t\t\t<td><button class=\"btn btn-primary btn-sm\" data-bind=\"visible: group(), click: addGroup\">Add</button></td>\n\t\t\t</tr>\n\t\t\t</tfoot>\n\t\t\t</table>\n\t\t</td>\n\t</tr>\n\t</tbody>\n\t</table>\n</div>"
});
